<template>
  <div class="mt-2 mx-3">
    <div>
      <v-sheet class="rounded-0 shadow-none" elevation="1" rounded>
        <v-row class="saved-lineup mt-2 mx-2" justify="center">
          <v-col cols="12" md="12" sm="12" class="mt-4">
            <!-- Selector starts -->
            <v-row class="d-none d-md-flex">
              <v-col cols="6" md="2" sm="6" class="body-2 text-center">
                <strong>Slate Time:</strong>
              </v-col>
              <v-col cols="6" md="2" sm="6" class="ml-n9 mt-n1">
                <v-select
                  light
                  :items="Slates"
                  item-text="OperatorName"
                  item-value="SlateID"
                  v-model="slateId"
                  solo
                  dense
                  @change="fetchPlayers(), fetchTopPlayer()"
                >
                  <template v-slot:item="{ item }">
                    <small class="caption">
                      {{ item.OperatorName }}&nbsp;
                      {{ item.OperatorStartTime | timeFormat }}
                      ({{ item.NumberOfGames }}games)
                    </small>
                  </template>
                </v-select>
              </v-col>
              <!-- Selector ends -->
              <!-- <p>{{ this.getSlateID }}</p> -->
              <!-- Radio buttons -->
              <v-col
                cols="12"
                md="3"
                sm="12"
                class="ml-6 mt-n8"
                align-self="center"
              >
                <v-radio-group v-model="radio" row>
                  <v-radio
                    label="Classic"
                    value="classic"
                    @change="onlyClassic()"
                  ></v-radio>
                  <v-radio
                    label="Single Game"
                    value="others"
                    @change="otherThanClassic()"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <!-- Radio buttons ends -->

              <!-- Selector starts -->
              <v-col
                cols="12"
                md="3"
                sm="12"
                class="body-2 text-center mt-n5"
                align-self="center"
              >
                <v-btn class="ml-1" color="info" @click="scrollToStud">
                  Stud
                </v-btn>
                <v-btn class="ml-1" color="info" @click="scrollToValue">
                  Value
                </v-btn>
                <!-- <v-btn class="ml-1" color="info" @click="scrollToSleeper">
                  Sleeper
                </v-btn> -->
              </v-col>
              <!-- Selector ends -->
            </v-row>

            <!-- only for mobile view -->
            <v-row class="d-block d-md-none mt-0">
              <v-col cols="5" md="4" sm="5" class="cus-radio-bnt float-left">
                <!-- Radio buttons -->
                <v-radio-group v-model="radio" row>
                  <v-radio
                    label="Classic"
                    value="classic"
                    @change="onlyClassic()"
                  ></v-radio>
                  <v-radio
                    label="Single Game"
                    value="others"
                    @change="otherThanClassic()"
                  ></v-radio>
                </v-radio-group>
                <!-- Radio buttons ends -->
              </v-col>
              <!-- Selector start -->
              <v-col
                cols="7"
                md="4"
                sm="5"
                class="body-2 float-right cus-caption-6 pt-0"
              >
                <strong>Slate Time:</strong>
                <v-select
                  light
                  :items="Slates"
                  item-text="OperatorName"
                  item-value="SlateID"
                  v-model="slateId"
                  solo
                  dense
                  @change="fetchPlayers(), fetchTopPlayer()"
                >
                  <template v-slot:item="{ item }">
                    <small class="caption">
                      {{ item.OperatorName }}&nbsp;
                      {{ item.OperatorStartTime | timeFormat }}
                      ({{ item.NumberOfGames }}games)
                    </small>
                  </template>
                </v-select>
              </v-col>
              <!-- Selector ends -->

              <!-- <p>{{ this.getSlateID }}</p> -->

              <!-- Selector starts -->
              <v-col
                cols="12"
                md="3"
                sm="12"
                class="body-2 text-center mt-n5 justify-content-center pb-0 float-left"
                align-self="center"
              >
                <v-btn
                  class="ml-1 cus-top-player"
                  color="info"
                  @click="scrollToStud"
                >
                  Stud
                </v-btn>
                <v-btn
                  class="ml-1 cus-top-player"
                  color="info"
                  @click="scrollToValue"
                >
                  Value
                </v-btn>
                <!-- <v-btn class="ml-1" color="info" @click="scrollToSleeper">
                  Sleeper
                </v-btn> -->
              </v-col>
              <!-- Selector ends -->
            </v-row>
            <!-- only for mobile view ends-->
          </v-col>
        </v-row>
      </v-sheet>
      <div v-if="loadingStatus">
        <v-skeleton-loader
          v-for="n in 3"
          :key="n"
          :loading="loadingStatus"
          class="mb-3 mt-4"
          type="list-item-avatar-two-line,table,paragraph"
          elevation="2"
        >
        </v-skeleton-loader>
      </div>

      <div v-else class="expansion-table-group">
        <!--//? Studs table-->
        <div class="mt-5">
          <v-expansion-panels popout focusable v-model="panel" id="stud">
            <v-expansion-panel v-model="panel">
              <v-expansion-panel-header class="text-sm-subtitle-2">
                STUDS
              </v-expansion-panel-header>
              <v-expansion-panel-content class="top-player-studs">
                <v-sheet elevation="3" class="mt-4">
                  <div>
                    <v-data-table
                      dense
                      :headers="computedHeaders"
                      :items="NewgetStuds"
                      :item-key="playersDetail._id"
                      class="elevation-1"
                      :footerProps="footerProps"
                      sort-by="DraftKingsProjection"
                      sort-desc
                      mobile-breakpoint="0"
                    >
                      <!-- header -->
                      <template
                        v-for="h in computedHeaders"
                        v-slot:[`header.${h.value}`]="{ computedHeaders }"
                      >
                        <v-tooltip bottom :key="h.text">
                          <template v-slot:activator="{ on }">
                            <span v-on="on">{{ h.text }}</span>
                          </template>
                          <span>{{ h.hint }}</span>
                        </v-tooltip>
                      </template>
                      <!-- header -->

                      <!-- profile image -->
                      <template v-slot:item.PhotoUrl="{ item }">
                        <v-avatar width="37" height="48">
                          <img :src="item.PhotoUrl" />
                        </v-avatar>
                      </template>
                      <!-- profile image ends -->

                      <!-- s.no -->
                      <template v-slot:item._id="{ index }">
                        <p class="body-2">{{ index + 1 }}</p>
                      </template>
                      <!-- s.no -->

                      <!-- player name -->
                      <template v-slot:item.Name="{ item }">
                        <router-link
                          :to="{
                            name: 'PlayerDetail',
                            params: {
                              playerId: item.PlayerID,
                              SportId: item.SportId,
                            },
                          }"
                          style="text-decoration: none"
                          class="caption"
                        >
                          {{ item.Name }}
                        </router-link>
                      </template>
                      <!-- player name ends -->

                      <!--//* matchup -->
                      <template v-slot:item.Team="{ item }">
                        <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
                          {{ item.Opponent }}&nbsp;
                          <small class="black--text">@</small>
                          <span>
                            {{ item.Team }}
                          </span>
                        </p>

                        <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
                          {{ item.Team }}&nbsp;
                          <small class="black--text">@</small>
                          <span>
                            {{ item.Opponent }}
                          </span>
                        </p>
                      </template>
                      <!--//* matchup ends -->

                      <template v-slot:item.HomeOrAway="{ item }">
                        <!-- Blue dot - 'active',
                        green dot - 'positive',
                        yellow dot -'intermediary'
                        red dot - 'negative' -->
                        <v-row class="ml-0">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-show="item.InjuryStatus == null"
                                v-on="on"
                                v-bind="attrs"
                              >
                                <status-indicator status="positive" pulse />
                              </v-col>
                            </template>
                            <span>Healthy</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-show="item.InjuryStatus == 'Out'"
                                v-on="on"
                                v-bind="attrs"
                              >
                                <status-indicator status="negative" pulse />
                              </v-col>
                            </template>
                            <span>Out</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="item.InjuryStatus == 'Questionable'"
                              >
                                <status-indicator status="intermediary" pulse />
                              </v-col>
                            </template>
                            <span>Questionable</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="item.InjuryStatus == 'Probable'"
                              >
                                <status-indicator status="active" pulse />
                              </v-col>
                            </template>
                            <span>Probable</span>
                          </v-tooltip>
                          <!-- 
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="item.HomeOrAway == 'HOME'"
                              >
                                <status-indicator status="positive" pulse />
                              </v-col>
                            </template>
                            <span>HOME</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-show="item.HomeOrAway == 'AWAY'"
                              >
                                <status-indicator status="negative" pulse />
                              </v-col>
                            </template>
                            <span>AWAY</span>
                          </v-tooltip> -->
                        </v-row>
                      </template>

                      <!-- salary -->
                      <template v-slot:item.DraftKingsSalary="{ item }">
                        <p
                          v-if="operator == 'DraftKings'"
                          class="body-2 green--text"
                        >
                          {{ item.DraftKingsSalary }}
                        </p>
                        <p v-else class="body-2 green--text">
                          {{ item.FanDuelSalary }}
                        </p>
                      </template>
                      <!-- salary ends -->

                      <!--//* DK Fp -->
                      <template v-slot:item.FPPDdraftking="{ item }">
                        <p class="caption" v-if="operator == 'DraftKings'">
                          ${{ item.FPPDdraftking >> 0 }}
                        </p>
                        <!-- <p v-else class="caption ">${{ item.FPPDfanduel >> 0 }}</p> -->
                      </template>
                      <!--//* DK Fp ends -->

                      <!--//* FD Fp -->
                      <template v-slot:item.FPPDfanduel="{ item }">
                        <p v-if="operator == 'FanDuel'" class="caption">
                          ${{ item.FPPDfanduel >> 0 }}
                        </p>
                      </template>
                      <!--//* FD Fp ends -->
                      <!-- FPPG -->
                      <template v-slot:item.FPPG="{ item }">
                        <p class="body-2">{{ item.FPPG >> 0 }}</p>
                      </template>
                      <!-- FPPG -->

                      <!-- projection -->
                      <template v-slot:item.DraftKingsProjection="{ item }">
                        <p v-if="operator == 'DraftKings'" class="body-2">
                          {{ item.DraftKingsProjection >> 0 }}
                        </p>
                        <p v-else class="body-2">
                          {{ item.FandDualProjection >> 0 }}
                        </p>
                      </template>
                      <!-- projection ends -->

                      <!-- add line up -->
                      <template v-slot:item._id="{ item }">
                        <v-row class="mt-n3">
                          <template v-if="item.type == 'lock'">
                            <!-- lock player button-->
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  x-small
                                  fab
                                  dark
                                  :id="'LockButton_' + item._id"
                                  color="green darken-3"
                                  @click="unlockExposure($event, item)"
                                >
                                  <v-icon>mdi-shield-lock-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Lock</span>
                            </v-tooltip>
                            <!-- exclude player button -->
                          </template>

                          <template v-else>
                            <!-- lock player button-->
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  x-small
                                  fab
                                  dark
                                  :id="'LockButton_' + item._id"
                                  color="blue"
                                  @click="lockExposure($event, item)"
                                >
                                  <v-icon>mdi-shield-lock-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Lock</span>
                            </v-tooltip>
                          </template>
                        </v-row>
                      </template>
                      <!-- add line up ends-->
                    </v-data-table>
                  </div>
                </v-sheet>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <!--//? studs table ends -->

        <!--//? value table -->
        <div class="mt-5">
          <v-expansion-panels popout focusable v-model="panel1" id="value">
            <v-expansion-panel v-model="panel1">
              <v-expansion-panel-header class="text-sm-subtitle-2">
                VALUE
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-sheet elevation="3" class="mt-4">
                  <div>
                    <v-data-table
                      dense
                      :headers="computedHeaders"
                      :items="getValue"
                      :item-key="playersDetail._id"
                      class="elevation-1"
                      :footerProps="footerProps"
                      mobile-breakpoint="0"
                      sort-by="FPPDdraftking"
                    >
                      <!-- header -->
                      <template
                        v-for="h in computedHeaders"
                        v-slot:[`header.${h.value}`]="{ computedHeaders }"
                      >
                        <v-tooltip bottom :key="h.text">
                          <template v-slot:activator="{ on }">
                            <span v-on="on">{{ h.text }}</span>
                          </template>
                          <span>{{ h.hint }}</span>
                        </v-tooltip>
                      </template>
                      <!-- header -->

                      <!-- profile image -->
                      <template v-slot:item.PhotoUrl="{ item }">
                        <v-avatar width="37" height="48">
                          <img :src="item.PhotoUrl" />
                        </v-avatar>
                      </template>
                      <!-- profile image ends -->

                      <!-- s.no -->
                      <template v-slot:item._id="{ index }">
                        <p class="body-2">{{ index + 1 }}</p>
                      </template>
                      <!-- s.no -->

                      <!-- player name -->
                      <template v-slot:item.Name="{ item }">
                        <router-link
                          :to="{
                            name: 'PlayerDetail',
                            params: {
                              playerId: item.PlayerID,
                              SportId: item.SportId,
                            },
                          }"
                          style="text-decoration: none"
                          class="caption"
                        >
                          {{ item.Name }}
                        </router-link>
                      </template>
                      <!-- player name ends -->
                      <!--//* matchup -->
                      <template v-slot:item.Team="{ item }">
                        <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
                          {{ item.Opponent }}&nbsp;
                          <small class="black--text">@</small>
                          <span>
                            {{ item.Team }}
                          </span>
                        </p>

                        <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
                          {{ item.Team }}&nbsp;
                          <small class="black--text">@</small>
                          <span>
                            {{ item.Opponent }}
                          </span>
                        </p>
                      </template>
                      <!--//* matchup ends -->

                      <template v-slot:item.HomeOrAway="{ item }">
                        <!-- Blue dot - 'active',
                        green dot - 'positive',
                        yellow dot -'intermediary'
                        red dot - 'negative' -->
                        <v-row class="ml-0">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-show="item.InjuryStatus == null"
                                v-on="on"
                                v-bind="attrs"
                              >
                                <status-indicator status="positive" pulse />
                              </v-col>
                            </template>
                            <span>Healthy</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-show="item.InjuryStatus == 'Out'"
                                v-on="on"
                                v-bind="attrs"
                              >
                                <status-indicator status="negative" pulse />
                              </v-col>
                            </template>
                            <span>Out</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="item.InjuryStatus == 'Questionable'"
                              >
                                <status-indicator status="intermediary" pulse />
                              </v-col>
                            </template>
                            <span>Questionable</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="item.InjuryStatus == 'Probable'"
                              >
                                <status-indicator status="active" pulse />
                              </v-col>
                            </template>
                            <span>Probable</span>
                          </v-tooltip>

                          <!-- <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="item.HomeOrAway == 'HOME'"
                              >
                                <status-indicator status="positive" pulse />
                              </v-col>
                            </template>
                            <span>HOME</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-show="item.HomeOrAway == 'AWAY'"
                              >
                                <status-indicator status="negative" pulse />
                              </v-col>
                            </template>
                            <span>AWAY</span>
                          </v-tooltip> -->
                        </v-row>
                      </template>

                      <!-- salary -->
                      <template v-slot:item.DraftKingsSalary="{ item }">
                        <p
                          v-if="operator == 'DraftKings'"
                          class="body-2 green--text"
                        >
                          {{ item.DraftKingsSalary }}
                        </p>
                        <p v-else class="body-2 green--text">
                          {{ item.FanDuelSalary }}
                        </p>
                      </template>
                      <!-- salary ends -->

                      <!--//* DK Fp -->
                      <template v-slot:item.FPPDdraftking="{ item }">
                        <p class="caption" v-if="operator == 'DraftKings'">
                          ${{ item.FPPDdraftking >> 0 }}
                        </p>
                        <!-- <p v-else class="caption ">${{ item.FPPDfanduel >> 0 }}</p> -->
                      </template>
                      <!--//* DK Fp ends -->

                      <!--//* FD Fp -->
                      <template v-slot:item.FPPDfanduel="{ item }">
                        <p v-if="operator == 'FanDuel'" class="caption">
                          ${{ item.FPPDfanduel >> 0 }}
                        </p>
                      </template>
                      <!--//* FD Fp ends -->

                      <!-- FPPG -->
                      <template v-slot:item.FPPG="{ item }">
                        <p class="body-2">{{ item.FPPG >> 0 }}</p>
                      </template>
                      <!-- FPPG -->

                      <!-- projection -->
                      <template v-slot:item.DraftKingsProjection="{ item }">
                        <p v-if="operator == 'DraftKings'" class="body-2">
                          {{ item.DraftKingsProjection >> 0 }}
                        </p>
                        <p v-else class="body-2">
                          {{ item.FandDualProjection >> 0 }}
                        </p>
                      </template>
                      <!-- projection ends -->

                      <!-- add line up -->
                      <template v-slot:item._id="{ item }">
                        <v-row class="mt-n3">
                          <template v-if="item.type == 'lock'">
                            <!-- lock player button-->
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  x-small
                                  fab
                                  dark
                                  :id="'LockButton_' + item._id"
                                  color="green darken-3"
                                  @click="unlockExposure($event, item)"
                                >
                                  <v-icon>mdi-shield-lock-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Lock</span>
                            </v-tooltip>
                            <!-- exclude player button -->
                          </template>

                          <template v-else>
                            <!-- lock player button-->
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  x-small
                                  fab
                                  dark
                                  :id="'LockButton_' + item._id"
                                  color="blue"
                                  @click="lockExposure($event, item)"
                                >
                                  <v-icon>mdi-shield-lock-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Lock</span>
                            </v-tooltip>
                          </template>
                        </v-row>
                      </template>
                      <!-- add line up ends-->
                    </v-data-table>
                  </div>
                </v-sheet>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <!-- <p>{{ NewgetStuds }}</p> -->
        <!--//? value table ends -->
      </div>
    </div>

    <!-- update Modal -->
    <upgrade-modal-2
      v-if="UpgradeModal"
      :UpgradeModal="UpgradeModal"
      @closeModal="goBack"
    />
    <!-- update Modal ends..-->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { showPlayers } from "@/mixins/showPlayers.js";
import UpgradeModal2 from "@/components/Modal/UpgradeModal2.vue";

export default {
  components: { UpgradeModal2 },
  mixins: [showPlayers],
  name: "TopPlayers",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],

  data: () => ({
    footerProps: { "items-per-page-options": [15, 30, 50, -1] },
    panel: 0,
    panel1: 0,
    panel2: 0,
    radio: "others",
    operator: "",
    operatorGameType: "",
    Slates: [],
    slateId: "",
    userId: localStorage.getItem("user"),
    UpgradeModal: false,

    DKheaders: [
      {
        text: "Profile",
        value: "PhotoUrl",
        hint: "profile",
      },
      { text: "", value: "_id", hint: "Lock" },

      {
        text: "Position",
        value: "DraftKingsPosition",
        sortable: false,
        hint: "position",
      },
      { text: "Player", value: "Name", hint: "name" },
      { text: "Game", value: "Team", hint: "game" },
      { text: "Status", value: "HomeOrAway", hint: "health status" },
      { text: "Salary($)", value: "DraftKingsSalary", hint: "salary" },
      { text: "FP($)", value: "FPPDdraftking", hint: "Fantasy Points" },
      { text: "FPPG", value: "FPPG", hint: "Fantasy point per game" },
      { text: "Proj.", value: "DraftKingsProjection", hint: "Projection" },
    ],
    FDheaders: [
      {
        text: "Profile",
        value: "PhotoUrl",
        hint: "profile",
      },
      { text: "", value: "_id", hint: "Lock" },

      {
        text: "Position",
        value: "FanDuelPosition",
        sortable: false,
        hint: "position",
      },
      { text: "Player", value: "Name", hint: "name" },
      { text: "Match", value: "Team", hint: "team" },
      { text: "Status", value: "HomeOrAway", hint: "health status" },
      { text: "Salary($)", value: "FanDuelSalary", hint: "salary" },
      { text: "FP($)", value: "FPPDfanduel", hint: "Fantasy Points" },
      { text: "FPPG", value: "FPPG", hint: "Fantasy point per game" },
      { text: "Proj.", value: "FandDualProjection", hint: "Projection" },
    ],
  }),

  beforeMount() {
    if (this.userState) {
      if (this.userState.plantype == "Free") {
        this.UpgradeModal = true;
      } else {
        this.UpgradeModal = false;
      }
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    scrollToValue() {
      let value = document.querySelector("#value");
      let option = { duration: 1000 };
      this.$vuetify.goTo(value, option);
    },

    scrollToStud() {
      let stud = document.querySelector("#stud");
      let option = { duration: 1000 };
      this.$vuetify.goTo(stud, option);
    },
    //   scrollToSleeper() {
    //   let sleeper = document.querySelector('#sleeper');
    //   let option = { duration: 1000 };
    //   this.$vuetify.goTo(sleeper, option);
    // },

    // ? lock player...
    async lockExposure(event, player) {
      let payload = {
        user: this.userId,
        min: 100,
        max: 100,
        slatId: this.slateId,
        playerId: player.PlayerID,
        teamId: player.TeamID,
        type: player.type == "lock" ? "" : "lock",
        slatePlayerID: player.SlatePlayerID,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
      };
      await this.$store.dispatch("NbaModule/SetExposure", payload).then(() => {
        //? update player info locally...
        this.updatePlayerInfo(payload);
      });
    },

    // * unlock player...
    async unlockExposure(event, player) {
      let payload = {
        playerId: player.PlayerID,
        user: this.userId,
        slatId: this.slateId,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
      };
      await this.$store
        .dispatch("NbaModule/unlockPlayers", payload)
        .then(async () => {
          this.updatePlayerInfo(payload);
        });
    },

    updatePlayerInfo(player) {
      // player index
      if (
        this.Slates[0]?.Operator === "DraftKings" &&
        this.$parent.radio === "others"
      ) {
        //console.log('check is working for other');
        let index = this.playersDetail.findIndex(
          (_player) => _player.playerrandomid === player.playerrandomid
        );
        if (index !== -1) {
          //check if player found in list
          let player_Info = this.playersDetail[index];
          Object.assign(player_Info, {
            min: player.min,
            max: player.max,
            type: player.type,
          });
          // update the player
          this.playersDetail.splice(index, 1, player_Info);
        }
      } else {
        //console.log('check is working for classic');
        let index = this.playersDetail.findIndex(
          (_player) => _player.PlayerID === player.playerId
        );
        // check if player found in list
        if (index !== -1) {
          let player_info = this.playersDetail[index];
          Object.assign(player_info, {
            min: player.min,
            max: player.max,
            type: player.type,
          });
          // update the player
          this.playersDetail.splice(index, 1, player_info);
        }
      }
    },
    fetchTopPlayer() {
      let obj = {
        operator: this.operator,
        gametype: this.operatorGameType,
        SlateID: this.slateId,
        userid: this.userId,
      };
      return this.$store.dispatch("MlbModule/GetTopPlayers", obj);
    },
  },
  computed: {
    ...mapGetters("MlbModule", ["loadingStatus", "getValue", "NewgetStuds"]),
    ...mapState("MlbModule", ["playersDetail"]),
    ...mapState("userModule", ["userState"]),

    computedHeaders() {
      if (this.defaultOptimizer) {
        if (this.defaultOptimizer == "DraftKings") {
          return this.DKheaders;
        } else {
          return this.FDheaders;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
